export enum SortDirection {
  ASC = 1,
  DESC = -1,
}
